if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.shirtOptions = ['size','fit'];
        setTimeout(this.updateSelectedOptionsFromQuerystring.bind(this), 200);
      }
      
      updateSelectedOptionsFromQuerystring() {
        
        // check for query params
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams && urlParams.size) {
          
          let inputsChanged = false;
          
          this.shirtOptions.forEach((option)=>{
            
            // get the option from the querystring
            const optionParam = urlParams.get(option);
            
            if (optionParam && optionParam != '') {
              
              // go through all the inputs for this option
              const inputs = Array.from(this.querySelectorAll(`.product-form__input--${option} input`));
              if (inputs && inputs.length) {
                for (let i = 0; i < inputs.length; i++) {
                  
                  const input = inputs[i];
                  
                  // find the input with the value from the querystring
                  if (input.value == optionParam) {
                    
                    // select this input if it's not already
                    if (!input.checked) {
                      inputsChanged = true
                      input.checked = true;
                      input.dispatchEvent(new Event('change'));
                    }
                    
                    // stop going through this option
                    break;
                  }
                }
              }
            }
          });
          
          // if anything changed, trigger an update
          if (inputsChanged) {
            
            this.dispatchEvent(new Event('change'));
          }
        }
      }
      
      updateAllQuerystrings() {
        
        let qs = '';
        
        this.shirtOptions.forEach((option)=>{
          
          // build the querystring
          
          const selectedInput = this.querySelector(`.product-form__input--${option} input:checked`);
          if (selectedInput) {
            qs += (qs == '') ? '?' : '&';
            qs += `${option}=${selectedInput.value}`;
          }
          
        });
        
        // go through all links that need the querystring
        
        const qsLinks = document.querySelectorAll('.product__info-column a[data-qs]');
        if (qsLinks) {
          qsLinks.forEach((link)=>{
            
            // split off the existing querystring and append the new one
            const url = link.href.split('?');
            link.href = url[0] + qs;
          });
        }
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          PCOtheme.pubsub.publish(PCOtheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;
        
        if (tagName === 'SELECT' && target.selectedOptions.length) {
          
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');
          
          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }
          
          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
          
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
        
        this.updateAllQuerystrings();
      }
    }
  );
}
